import React from 'react'
import Edit from '../crud/edit'

const EditHomeworkSection = (props) => {
  return (
    <Edit
// @ts-ignore
      title='Editing Homework Section'
      fields={require('./fields')(props.params.homeworkId)}
      apiPath={`admin/homework_sections/${props.params.homeworkSectionId}`}
      successRedirectPath={`/write-now/homework/${props.params.homeworkId}/edit?tab=sections`}
    />
  )
}

export default EditHomeworkSection
